const TOOLTIP =
    "Filter a given control's contents based on the current user matching the 'identity:user' field. E.g. filtering personal Saved Filters to only those from the current user";

function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    //Just the tooltip, nothing configurable here.
    blocklyBlock.setTooltip(TOOLTIP);
}

function convertCustomFieldsToCode(code, blocklyBlock) {
    //hardcode what we are matching against
    code.namespace = 'identity';
    code.relation = 'user';
    return code;
}

/** Builds the filter metadata fragment for the ByCurrentUser block. */
function asDataDictionary(hNode, context) {
    const { namespace, relation } = hNode;
    //We know that the referenced namespace/relation must exist
    // Foreign relations are declared by registerForeignKey
    let subDataDictionary = {};
    //And the given foreignKey exists on the parent object.
    // Filters always require the foreign key reference
    return [subDataDictionary, context.registerForeignKey(namespace, relation, [])];
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode, asDataDictionary };